import { render, staticRenderFns } from "./EditorCard.vue?vue&type=template&id=14776c68&scoped=true&"
import script from "./EditorCard.vue?vue&type=script&lang=js&"
export * from "./EditorCard.vue?vue&type=script&lang=js&"
import style0 from "./EditorCard.vue?vue&type=style&index=0&id=14776c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14776c68",
  null
  
)

export default component.exports